import createVueComponent from '../createVueComponent';

const Flag = createVueComponent('FlagIcon', [
  [
    'path',
    {
      d: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z',
      key: 'i9b6wo',
    },
  ],
  ['line', { x1: '4', x2: '4', y1: '22', y2: '15', key: '1cm3nv' }],
]);

export default Flag;
